let mixin = {
    props: {
        param: { //渲染对象
            type: Object,
            default: () => ({})
        },
        formData: { //表单对象
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        d() {
            return this.param;
        },
    },
    data() {
        return {
            options: [],
        }
    },
    created() {
        if (this.d.options) {
            var type = Object.prototype.toString
                .call(this.d.options)
                .replace(/\[object\s|\]/g, "");

            type == "Array" ? this.options = this.d.options : this.d.options.then((res) => this.options = res);
        }
    },
    methods: {
        change(val){
            console.log(val)
            this.$emit("changes", val);
        }
    }
}
export default mixin;